module.exports = __webpack_public_path__ + "static/mt-logo.98b84069.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mt-logo.svg
// module id = 1487
// module chunks = 168707334958949